<div class="weekly-forecast-container" *ngIf="!hasError; else errorTpl">
    <div *ngIf="isLoading" class="loading-state">
      <p>Loading weekly forecast...</p>
      <!-- You can replace this with a spinner -->
      <!-- <mat-spinner></mat-spinner> -->
    </div>
  
    <div *ngIf="!isLoading && !isEmpty">
      <!-- Chart Card -->
      <div class="forecast-card">
        <canvas
          baseChart
          [data]="lineChartData"
          [type]="lineChartType"
          [options]="lineChartOptions"
        >
        </canvas>
      </div>
    </div>
  
    <div *ngIf="!isLoading && isEmpty" class="empty-state">
      <p>No forecast data available.</p>
    </div>
  </div>
  
  <!-- Error Template -->
  <ng-template #errorTpl>
    <div class="error-msg">
      <p>Failed to load weekly forecast data. Please try again later.</p>
    </div>
  </ng-template>
  